<template>
  <div>
    <el-popover :width="showVisibleSwitch ? 1410 : 1010" append-to-body placement="right" trigger="click">
      <el-form :disabled="false">
        <div style="border: 1px solid #dcdfe6; border-radius: 4px; box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04)">
          <div class="flexV" style="height: 50px; border-bottom: 1px solid #dcdfe6">
            <span style="margin-left: 10px; font-size: 15px">字段顺序调整(按住拖拽) Tips:冻结为列固定始终排序在最前!</span>
            <el-button
              class="vg_cursor"
              size="mini"
              style="margin-left: auto; margin-right: 18px"
              type="primary"
              @click="saveColumnsFixedStatus"
            >
              保存
            </el-button>
          </div>
          <div style="padding: 10px">
            <draggable
              v-model="columnsPropertiesList"
              :class="showVisibleSwitch ? 'list-group1' : 'list-group'"
              v-bind="{
                animation: 150,
                group: 'description',
                disabled: false,
                ghostClass: 'ghost',
                draggable: '.draggable'
              }"
            >
              <div
                v-for="(element, index) in columnsPropertiesList"
                :key="element.label"
                :class="`${showVisibleSwitch ? 'list-group-item1' : 'list-group-item'} vg_cursor ${element.unDraggable ? '' : 'draggable'}`"
              >
                <span>{{ index + 1 }}.{{ element.label }}</span>
                <div style="margin-left: auto">
                  <span>冻结:</span>
                  <el-switch
                    v-model="element.fixed"
                    :disabled="element.unDraggable"
                    :inactive-value="null"
                    active-color="#13ce66"
                    active-value="left"
                    inactive-color="#ff4949"
                  >
                  </el-switch>
                  <span v-if="showVisibleSwitch" style="margin-left: 5px">显示:</span>
                  <el-switch
                    v-if="showVisibleSwitch"
                    v-model="element.visible"
                    :active-value="true"
                    :disabled="element.cannotHidden"
                    :inactive-value="false"
                    active-color="#13ce66"
                    inactive-color="#ff4949"
                  >
                  </el-switch>
                </div>
              </div>
            </draggable>
          </div>
        </div>
      </el-form>
      <el-link slot="reference" class="vg_cursor" size="mini" type="primary" @click="e => e.stopPropagation()">配置</el-link>
    </el-popover>
  </div>
</template>
<script>
import Draggable from 'vuedraggable';
import { cloneDeep } from 'lodash';

export default {
  name: 'ColumnPropertiesList',
  components: { Draggable },
  props: ['columnsFixedStatus', 'titleFrom'],
  data() {
    return {
      showVisibleSwitch: [
        '/prodcontrol_list',
        '/fequSample_list',
        '/makeSampleControlTable',
        '/pomodrsum_statistics',
        '/pomodrdetail_statistics',
        '/tran_list',
        '/scon_list',
        '/tapp_list'
      ].includes(this.$route.path),
      mainPageListIncludesPath: [
        '/prodcontrol_list',
        '/fequ_list',
        '/modr_list',
        '/podr_list',
        '/fequSample_list',
        '/makeSampleControlTable',
        '/spin_list',
        '/scon_list',
        '/tran_list',
        '/tapp_list',
        '/pomodrsum_statistics',
        '/pomodrdetail_statistics'
      ].includes(this.$route.path),
      editPageListIncludesPath: ['/tran_edit', '/podr_edit', '/modr_edit', '/scon_edit', '/podc_edit', '/modc_edit', '/fequ_edit'].includes(
        this.$route.path
      ),
      columnsPropertiesList: cloneDeep(this.columnsFixedStatus)
    };
  },
  methods: {
    saveColumnsFixedStatus() {
      // let permId;
      // if (this.mainPageListIncludesPath) permId = this.$route.query.perm_id;
      // if (this.editPageListIncludesPath) permId = JSON.parse(UrlEncode.decode(this.$route.query.key)).perm_id;
      // if (!permId) return;
      // const { user_id } = this.$cookies.get('userInfo');
      // const columnConfiguration = JSON.stringify(this.columnsPropertiesList);
      // openAPI.editPageOrder({ user_id, perm_id: permId, column_configuration: columnConfiguration, title_from: this.titleFrom }).then(() => {
      //   this.$emit('closeOperationBtnShow');
      //   this.$message.success('保存成功!');
      //   this.$emit('loadProperties');
      // });
    }
  }
};
</script>
<style scoped>
::v-deep :root {
  --base-padding-right: 45px; /* 初始基础padding-right值 */
}

::v-deep .el-input textarea {
  padding-bottom: 13px;
}

.list-group-item {
  background-color: #fff;
  border: 1px solid #e4e7ed;
  width: 200px;
  height: 50px;
  display: flex;
  align-items: center;
  padding-left: 15px;
  padding-right: 15px;
  border-radius: 4px;
  margin-bottom: 10px;
  box-shadow: 2px 2px 1px 0 rgba(0, 0, 0, 0.1);
}

.list-group-item1 {
  background-color: #fff;
  border: 1px solid #e4e7ed;
  width: 300px;
  height: 50px;
  display: flex;
  align-items: center;
  padding-left: 15px;
  padding-right: 15px;
  border-radius: 4px;
  margin-bottom: 10px;
  box-shadow: 2px 2px 1px 0 rgba(0, 0, 0, 0.1);
}

.list-group {
  display: grid;
  grid-template-columns: 250px 250px 250px 250px;
  padding-left: 0;
  margin-bottom: 0;
  min-height: 20px;
}

.list-group1 {
  display: grid;
  grid-template-columns: 350px 350px 350px 350px;
  padding-left: 0;
  margin-bottom: 0;
  min-height: 20px;
}

.ghost {
  background: #606266;
  color: #fff;
  cursor: pointer;
}
</style>
